import { type UseQueryOptions, useQuery } from '@tanstack/react-query';
import { getProject as apiGetProject } from '~/api/projects2';
import type { Project } from '~/common/types';

export interface UseGetProjectOptions {
  projectId?: string;
}

export function useGetProject<T = Project>(
  { projectId }: UseGetProjectOptions,
  options?: Partial<UseQueryOptions<T, Error, T, (string | UseGetProjectOptions)[]>>,
) {
  return useQuery({
    enabled: !!projectId,
    queryKey: ['project', { projectId }],
    queryFn: () => apiGetProject<T>(projectId!),
    ...options,
  });
}
